const React = require('react');
const T = require('prop-types');
const Moment = require('moment');
const { default: Styled } = require('styled-components');

const { default: Typography } = require('@mui/material/Typography');
const { default: Avatar } = require('@mui/material/Avatar');
const { default: ListItem } = require('@mui/material/ListItem');
const { default: ListItemAvatar } = require('@mui/material/ListItemAvatar');
const { default: ListItemText } = require('@mui/material/ListItemText');
const { default: ListItemSecondaryAction } = require('@mui/material/ListItemSecondaryAction');

const { default: GroupIcon } = require('@mui/icons-material/Group');
const UnreadMessagesBadge = require('../../../../../routes/app/components/UnreadMessagesBadge');
const Emoji = require('components/Emoji');
const { transient$Props } = require('utils/styles');
const ItemBody = require('../../../components/Chat/ItemBody');

const internals = {};

module.exports = class ClassListItem extends React.Component {

    static propTypes = {
        action: T.func,
        className: T.string,
        middleIcon: T.node,
        middleActionButton: T.node,
        darkBackground: T.bool,
        titleClass: T.string,
        subtitleClass: T.string,
        unreadCount: T.number,
        titleFontSize: T.number,
        showPrivate: T.bool,
        showChatDetails: T.bool,
        usersNameMap: T.object,
        currentUserId: T.number,
        lastMessage: T.shape({
            author: T.number,
            body: T.string,
            timestamp: T.string
        }),
        group: T.shape({
            name: T.string,
            professor: T.string,
            emojiSymbol: T.string,
            facilitator: T.string,
            campus: T.string,
            shortDescription: T.string,
            number: T.string,
            additionalDescription: T.string,
            location: T.string,
            room: T.string,
            isAnnouncement: T.bool,
            private: T.bool,
                channel: T.oneOfType([
                    T.oneOf([null]),
                    T.shape({
                        hasUnreads: T.bool,
                        lastMessage: T.shape({
                            author: T.number,
                            body: T.string,
                        timestamp: T.string
                    })
                })
            ]),
                conversation: T.oneOfType([
                    T.oneOf([null]),
                    T.shape({
                        hasUnreads: T.bool
                    })
                ]),
            type: T.string
        }),
        displayDetails: T.bool,
        truncateDetails: T.bool,
        link: T.string,
        showDivider: T.bool,
        push: T.func,
        onClick: T.func,
        isHeader: T.bool,
        isDetailsHeader: T.bool,
        debug: T.bool
    }

    action = (event) => {

        if (event) {
            event.preventDefault();
        }

        if (!this.props.action) {
            return;
        }

        // TODO find out if this is still true:
        // We wait because onClick has some funny timing triggering a click event as well.
        // If we dont wait to show (for example) a confirmation dialog, it fires twice!
        setTimeout(() => {

            this.props.action(this.props.group);
        });
    }

    renderLastMessage() {

        const { SecondaryTextContainer } = internals;
        const { lastMessage, usersNameMap, currentUserId } = this.props;

        const isMe = lastMessage.author === currentUserId;
        const authorName = isMe ? 'You' : (usersNameMap?.[lastMessage.author] || 'Unknown User');

        return (
            <SecondaryTextContainer $isMe={isMe}>
                <span style={{ fontWeight: 'bold' }}>{authorName}:</span>
                {' '}
                <ItemBody
                    isPreview={true}
                    isMe={isMe}
                    isGroupPreview={true}
                >
                    {lastMessage.body}
                </ItemBody>
            </SecondaryTextContainer>
        );
    }

    render() {

        const {
            middleActionButton = null,
            darkBackground = false,
            titleFontSize = null,
            middleIcon,
            unreadCount,
            showPrivate = true,
            showChatDetails = false,
            lastMessage,
            group: {
                name,
                emojiSymbol,
                private: classIsPrivate,
                shortDescription,
                additionalDescription,
                isAnnouncement,
                facilitator,
                campus,
                location,
                professor,
                room
            },
            displayDetails,
            truncateDetails,
            link,
            push,
            onClick,
            isHeader,
            isDetailsHeader,
            className,
            debug,
            ...rest
        } = this.props;

        const {
            truncate,
            OuterContainer,
            TitleTextContainer,
            TitleText,
            TitleTimestamp,
            StyledListItemAvatar,
            StyledListItem,
            MiddleTextContainer,
            MiddleActionButtonContainer,
            StyledUnreadMessagesBadge,
            SecondaryTextHolder,
            SecondaryTextContents,
            AnnouncementsLabel
        } = internals;

        let LeftIcon = GroupIcon;

        if (emojiSymbol) {
            // eslint-disable-next-line react/display-name
            LeftIcon = (iconProps) => {

                return <Emoji {...iconProps} symbol={emojiSymbol} />;
            };
        }

        const middleActionButtonFocusOutline = middleActionButton?.props?.['data-focus-outline']
            || 'radius:40,padding:3,zIndex:2';

        const middleActionButtonWithAction = (middleActionButton && this.props.action) ? React.cloneElement(middleActionButton, {
            onClick: this.action,
            type: middleActionButton?.props?.type || 'button',
            'data-focus-outline': middleActionButtonFocusOutline,
            onKeyDown: (evt) => {

                if (evt.key === 'Enter' || evt.code === 'Space') {
                    this.action(evt);
                }
            }
        }) : middleActionButton || null;

        const lastMessageTimestamp = lastMessage?.timestamp;
        const relativeLanguageTimestamp = !isHeader && lastMessageTimestamp && Moment(lastMessageTimestamp)
            .calendar(null, {
                lastDay : '[Yesterday] [at] LT',
                sameDay : '[Today] [at] LT',
                nextDay : '[Tomorrow]',
                lastWeek : 'dddd [at] LT',
                nextWeek : 'dddd',
                sameElse : 'MM/DD/YYYY [at] LT'
            });

        const _onClick = (evt) => {

            if (evt?.target?.tagName?.toLowerCase() === 'button') {
                evt.preventDefault();
                return;
            }

            // Run onClick if exists
            onClick?.();

            if (link) {
                push(link);
            }
        };

        return (
            <OuterContainer
                className={className}
                style={{
                    display: 'flex',
                    flexFlow: 'row nowrap',
                    position: 'relative',
                    marginTop: 12,
                    paddingRight: 12
                }}
            >
                <StyledListItem
                    $hasLink={!!link}
                    aria-label={link ? `Go to ${name}` : name}
                    component={link ? 'button' : 'li'}
                    type={link ? 'button' : undefined}
                    tabIndex={link ? undefined : -1}
                    {...rest}
                    onClick={_onClick}
                    onKeyDown={(evt) => {

                        if (evt.key === 'Enter') {
                            _onClick(evt);
                        }
                    }}
                >
                    <StyledListItemAvatar>
                        <Avatar style={{ width: 46, height: 46 }}>
                            <LeftIcon
                                style={{
                                    padding: 0,
                                    fontSize: 32
                                }}
                            />
                        </Avatar>
                        {!!unreadCount && unreadCount > 0 && <StyledUnreadMessagesBadge numUnreads={unreadCount} />}
                    </StyledListItemAvatar>
                    <MiddleTextContainer>
                        <ListItemText
                            primary={<TitleTextContainer $darkBackground={darkBackground}>
                                <TitleText $titleFontSize={titleFontSize}>{name}</TitleText>
                                {relativeLanguageTimestamp && <TitleTimestamp $darkBackground={darkBackground}>
                                    {relativeLanguageTimestamp}
                                </TitleTimestamp>}
                            </TitleTextContainer>}
                            secondary={(showChatDetails && lastMessage) ? this.renderLastMessage() : displayDetails && (additionalDescription || shortDescription || (showPrivate && classIsPrivate) || isAnnouncement) && (
                                <SecondaryTextHolder $isHeader={isHeader}>
                                    {!isAnnouncement && showPrivate && classIsPrivate && (
                                        <div
                                            style={{
                                                fontSize: 11,
                                                fontStyle: 'italic'
                                            }}
                                        >
                                            (PRIVATE)
                                        </div>
                                    )}
                                    {isAnnouncement && <AnnouncementsLabel $isHeader={isHeader}>(ANNOUNCEMENTS ONLY)</AnnouncementsLabel>}
                                    <SecondaryTextContents $isHeader={isHeader}>
                                        {facilitator && isDetailsHeader ? <div><b>Facilitator:</b>&nbsp;{facilitator}</div> : <div />}
                                        {professor && isDetailsHeader ? <div><b>Professor:</b>&nbsp;{professor}</div> : <div />}
                                        {campus && isDetailsHeader ? <div><b>Campus:</b>&nbsp;{campus}</div> : <div />}
                                        {location && isDetailsHeader ? <div><b>Location:</b>&nbsp;{location}{room && ` ${room}`}</div> : <div />}
                                        {shortDescription ? <div>{truncateDetails ? truncate(shortDescription) : shortDescription}</div> : null}
                                        {additionalDescription ? <div>{truncateDetails ? truncate(additionalDescription) : additionalDescription}</div> : null}
                                    </SecondaryTextContents>
                                </SecondaryTextHolder>
                            )}
                        />
                        {middleIcon && (
                            <ListItemSecondaryAction component='div' style={{ right: 5 }}>
                                {middleIcon}
                            </ListItemSecondaryAction>
                        )}
                    </MiddleTextContainer>
                </StyledListItem>
                {middleActionButtonWithAction && (
                    <div
                        className='nearpeer-class-list-item-action'
                        onClick={internals.stopActionRailEvent}
                        onMouseDown={internals.stopActionRailEvent}
                        onKeyDown={internals.stopActionRailKeyDown}
                        style={{
                            marginTop: 12,
                            paddingLeft: isHeader ? 0 : 10
                        }}
                    >
                        <MiddleActionButtonContainer>
                            {middleActionButtonWithAction}
                        </MiddleActionButtonContainer>
                    </div>
                )}
            </OuterContainer>
        );
    }
};

internals.truncate = (str, max = 200) => {

    return str.length > max ? `${str.slice(0, max)}...` : str;
};

internals.OuterContainer = Styled.div`
    &.nearpeer-group-list-item {
        width: 100%;
        box-sizing: border-box;
        align-items: center;
        margin: 4px 0 10px !important;
        padding: 6px 12px 6px 0 !important;
        border-radius: 16px !important;
        background: rgba(248, 250, 252, 0.96) !important;
        border: 1px solid rgba(18, 39, 79, 0.09);
        transition: background 120ms ease, transform 120ms ease;
    }

    &.nearpeer-group-list-item:hover {
        background: ${({ theme }) => theme.palette.primary.main}14 !important;
        border-color: ${({ theme }) => theme.palette.primary.main}40;
    }

    &.nearpeer-group-list-item > .MuiListItem-root {
        flex: 1;
        min-height: 66px;
        background: transparent !important;
    }

    &.nearpeer-group-list-item > .MuiListItem-root::after,
    &.nearpeer-group-list-item .MuiListItem-root::after {
        display: none;
    }

    &.nearpeer-group-list-item .nearpeer-class-list-item-action {
        display: flex;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        min-width: 64px;
        margin-top: 0 !important;
        margin-left: 4px;
        padding-left: 12px !important;
        padding-right: 2px;
        border-left: 1px solid rgba(18, 39, 79, 0.10);
        cursor: default;
    }

    &.nearpeer-group-list-item .nearpeer-class-list-item-action .MuiButtonBase-root {
        box-shadow: none !important;
    }

    &.nearpeer-group-list-item .nearpeer-class-list-item-action .MuiButtonBase-root:hover,
    &.nearpeer-group-list-item .nearpeer-class-list-item-action .MuiButtonBase-root.Mui-focusVisible {
        box-shadow: none !important;
    }

    &.nearpeer-group-list-item .MuiAvatar-root {
        background: #fff;
        border: 1px solid rgba(18, 39, 79, 0.12);
        box-sizing: border-box;
        transition: background 120ms ease;
    }

    &.nearpeer-group-list-item:hover .MuiAvatar-root {
        background: #fff !important;
    }
`;

internals.TitleTextContainer = Styled('div')`
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    box-sizing: border-box;
    padding-right: 108px;
    color: ${({ theme, $darkBackground }) => $darkBackground ? theme.palette.primary.contrastText : 'inherit'};
`;

internals.TitleText = Styled(Typography, transient$Props).attrs({
    variant: 'h2'
})`
    flex: 1;
    min-width: 0;
    font-size: ${({ $titleFontSize }) => $titleFontSize || '22'}px;
    font-weight: 500;
`;

internals.TitleTimestamp = Styled.span`
    position: absolute;
    top: -2px;
    right: 0px;
    color: ${({ theme, $darkBackground }) => $darkBackground ? theme.palette.primary.contrastText : '#5f6368'};
    font-size: 11px;
    font-weight: 600;
    line-height: 1.5;
    white-space: nowrap;
`;

internals.StyledListItemAvatar = Styled(ListItemAvatar)`
    && {
        position: relative;
        align-self: center;

        .MuiAvatar-circular,
        .MuiAvatar-root {
            background: white;
            box-shadow: none;
        }
    }
`;

internals.StyledListItem = Styled(ListItem, transient$Props)`
    min-height: 58px;
    width: 100%;
    border: 0;
    appearance: none;
    background: transparent;
    color: inherit;
    font: inherit;
    text-align: left;
    padding-left: 10px;

    display: flex;
    flex-flow: row nowrap;

    position: relative;
    padding-right: 0;
    padding-bottom: 6px;

    .MuiListItem-container {
        flex: 1;
    }

    ${({ theme, $hasLink }) => {

        if ($hasLink) {
            return `
                cursor: pointer;

                &:hover {
                    background-color: ${theme.palette.menu.hover};
                }
            `;
        }
    }}
`;

internals.MiddleTextContainer = Styled.div`
    flex-grow: 1;
    align-self: center;
    padding-top: 0;
    padding-right: 36px;
    overflow: hidden;
    min-width: 0;

    .MuiListItemText-root {
        margin: 4px 0;
    }
`;

internals.MiddleActionButtonContainer = Styled.div`
    align-self: center;
`;

internals.StyledUnreadMessagesBadge = Styled(UnreadMessagesBadge)`
    position: absolute !important;
    top: 6px;
    right: 20px;
`;

internals.SecondaryTextHolder = Styled('div', transient$Props)`
    height: auto !important;
    width: 100%;
    white-space: normal !important;
    font-size: 15px;
    line-height: 16px;
    padding: 10px 0;
    padding-right: ${({ $isHeader }) => $isHeader ? 8 : 25}px;
    color: ${({ theme, $isHeader }) => $isHeader ? theme.palette.primary.contrastText : theme.palette.text.secondary};
`;

internals.SecondaryTextContents = Styled('div', transient$Props)`
    font-size: 14px;
    line-height: 18px;
    width: 100%;
    margin-top: 4px !important;

    ${({ theme, $isHeader }) => {

        if ($isHeader) {
            return `
                color: ${theme.palette.primary.contrastText}
                font-size: 14px;
                line-height: 18px;
            `;
        }

        return `
            color: ${theme.palette.text.secondary}
        `;
    }}
`;

internals.AnnouncementsLabel = Styled('div', transient$Props)`
    color: ${({ theme, $isHeader }) => $isHeader ? theme.palette.primary.contrastText : theme.palette.text.secondary};
    margin-top: 0;
    margin-bottom: 4px;
    font-style: italic;
    font-size: 11px;
`;

internals.SecondaryTextContainer = Styled.div`
    display: block;
    color: white;
    background-color: ${({ theme }) => theme.palette.tertiary.main};
    padding: 0.25rem 0.5rem;
    border-radius: 8px;
    margin-top: 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 80%;
    width: fit-content;
    text-align: ${({ $isMe }) => $isMe ? 'right' : 'left'};
    margin-left: ${({ $isMe }) => $isMe ? 'auto' : '0'};
    margin-right: ${({ $isMe }) => $isMe ? '0' : 'auto'};

    a {
        color: ${({ theme }) => theme.palette.tertiary.contrastText};
    }
`;